import axios from "axios";
import Config from "./../../config/index";
import RefreshTokenHandler from "./refresh-token";

// Add new company
const addCompany = async (
  email: string,
  amc_code: string,
  company_code: string,
  name_of_company: string,
  tax_collector?: string,
  ntn?: number,
  account_title?: string,
  IBAN?: string,
  txn_creator_field?: Array<{ name: string; email: string }>,
  amc_signatories?: Array<{ name: string; email: string }>,
  concerned_officer?: string,
  substitude_concerned_officer?: string,
  company_focal_name?: string,
  company_focal_email?: string,
  mobile?: string,
  phone?: string,
  billing_contact?: Array<{
    name: string;
    email: string;
    designation: string;
    contact_no: string;
  }>,
  company_type?: string,
  company_logo: string = ""
) => {
  const url = `${Config.baseUrl}/company`;
  try {
    const formData = new FormData();

    if (company_logo) {
      formData.append("company_logo", company_logo);
    }

    formData.append(
      "data",
      JSON.stringify({
        email,
        amc_code,
        company_code,
        name_of_company,
        tax_collector,
        ntn,
        account_title,
        IBAN,
        txn_creator_field,
        amc_signatories,
        concerned_officer,
        substitude_concerned_officer,
        company_focal_name,
        company_focal_email,
        mobile,
        phone,
        billing_contact,
        company_type,
      })
    );
    let result: any = await axios.post(
      url,
      // {
      //   email,
      //   amc_code,
      //   company_code,
      //   name_of_company,
      //   tax_collector,
      //   ntn,
      //   account_title,
      //   IBAN,
      //   txn_creator_field,
      //   amc_signatories,
      //   concerned_officer,
      //   substitude_concerned_officer,
      //   company_focal_name,
      //   company_focal_email,
      //   mobile,
      //   phone,
      //   billing_contact,
      //   company_type,
      //   company_logo
      // },
      formData,
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response?.data?.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addCompany(
          email,
          amc_code,
          company_code,
          name_of_company,
          tax_collector,
          ntn,
          account_title,
          IBAN,
          txn_creator_field,
          amc_signatories,
          concerned_officer,
          substitude_concerned_officer,
          company_focal_name,
          company_focal_email,
          mobile,
          phone,
          billing_contact,
          company_type,
          company_logo
        );
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

// Get all companies with search and pagination
const getAllCompanies = async (params: {
  email: string;
  amc_code?: string;
  company_code?: string;
  name_of_company?: string;
  search?: string;
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_order?: string;
  fetch_all?: string;
}) => {
  const {
    email,
    amc_code,
    company_code,
    name_of_company,
    search,
    page = 1,
    limit = 10,
    sort_by,
    sort_order,
    fetch_all,
  } = params;
  let url = `${Config.baseUrl}/company?email=${email}`;

  if (amc_code) url += `&amc_code=${amc_code}`;
  if (company_code) url += `&company_code=${company_code}`;
  if (name_of_company) url += `&name_of_company=${name_of_company}`;
  if (search) url += `&search=${search}`;
  if (page) url += `&page=${page}`;
  if (limit) url += `&limit=${limit}`;
  if (sort_by) url += `&sort_by=${sort_by}`;
  if (sort_order) url += `&sort_order=${sort_order}`;
  if (fetch_all) url += `&fetch_all=${fetch_all}`;

  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response?.data?.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllCompanies({
          email,
          amc_code,
          company_code,
          name_of_company,
          search,
          page,
          limit,
          sort_by,
          sort_order,
          fetch_all,
        });
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

// Get single company by ID
const getCompanyById = async (email: string, company_id: string) => {
  const url = `${Config.baseUrl}/company/${company_id}?email=${email}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response?.data?.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getCompanyById(email, company_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

// Edit/Update company
const editCompany = async (
  email: string,
  company_id: string,
  updateData?: any
) => {
  const url = `${Config.baseUrl}/company/${company_id}`;
  try {
    let result: any = await axios.put(
      url,
      {
        email,
        company_id,
        ...updateData,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response?.data?.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await editCompany(email, company_id, updateData);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

// Get companies by AMC code
const getCompaniesByAMC = async (email: string, amc_code: string) => {
  const url = `${Config.baseUrl}/company/by-amc?email=${email}&amc_code=${amc_code}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response?.data?.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getCompaniesByAMC(email, amc_code);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

// Bulk upload companies
const bulkUploadCompanies = async (
  email: string,
  AmcCode: string,
  data: any
) => {
  const url = `${Config.baseUrl}/company/bulk-upload`;
  try {
    let result: any = await axios.post(
      url,
      {
        email,
        AmcCode,
        data,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response?.data?.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await bulkUploadCompanies(email, AmcCode, data);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

const getHeaders = () => ({
  Authorization: sessionStorage.getItem("token") || "",
});

const getCompanyDashboardAnalytics = async (params: {
  email: string;
  company_code: string;
  period?: string;
  start_date?: string;
  end_date?: string;
}) => {
  const { email, company_code, period, start_date, end_date } = params;

  let url = `${Config.baseUrl}/company/analytics/dashboard?email=${email}&company_code=${company_code}`;

  if (period) url += `&period=${period}`;
  if (start_date) url += `&start_date=${start_date}`;
  if (end_date) url += `&end_date=${end_date}`;

  try {
    return await axios.get(url, { headers: getHeaders() });
  } catch (err: any) {
    if (err.response?.data?.status === 401) {
      const result = await RefreshTokenHandler.handleIt(err.response.data);
      if (result.status) {
        return getCompanyDashboardAnalytics(params);
      }
    }
    throw err;
  }
};

const getCompanyFundsAnalytics = async (params: {
  email: string;
  company_code: string;
  symbol_code: string;
  start_date?: string;
  end_date?: string;
}) => {
  const { email, company_code, symbol_code, start_date, end_date } = params;

  let url = `${Config.baseUrl}/company/analytics/funds?email=${email}&company_code=${company_code}&symbol_code=${symbol_code}`;

  if (start_date) url += `&start_date=${start_date}`;
  if (end_date) url += `&end_date=${end_date}`;

  try {
    return await axios.get(url, { headers: getHeaders() });
  } catch (err: any) {
    if (err.response?.data?.status === 401) {
      const result = await RefreshTokenHandler.handleIt(err.response.data);
      if (result.status) {
        return getCompanyFundsAnalytics(params);
      }
    }
    throw err;
  }
};
const getCompanyEmployeesAnalytics = async (params: {
  email: string;
  company_code: string;
  folio_no?: string;
  search?: string;
}) => {
  const { email, company_code, folio_no, search } = params;

  let url = `${Config.baseUrl}/company/analytics/employees?email=${email}&company_code=${company_code}`;

  if (folio_no) url += `&folio_no=${folio_no}`;
  if (search) url += `&search=${search}`;

  try {
    return await axios.get(url, { headers: getHeaders() });
  } catch (err: any) {
    if (err.response?.data?.status === 401) {
      const result = await RefreshTokenHandler.handleIt(err.response.data);
      if (result.status) {
        return getCompanyEmployeesAnalytics(params);
      }
    }
    throw err;
  }
};
const getCompanyLoansAnalytics = async (params: {
  email: string;
  company_code: string;
  period?: string;
  start_date?: string;
  end_date?: string;
}) => {
  const { email, company_code, period, start_date, end_date } = params;

  let url = `${Config.baseUrl}/company/analytics/loans?email=${email}&company_code=${company_code}`;

  if (period) url += `&period=${period}`;
  if (start_date) url += `&start_date=${start_date}`;
  if (end_date) url += `&end_date=${end_date}`;

  try {
    return await axios.get(url, { headers: getHeaders() });
  } catch (err: any) {
    if (err.response?.data?.status === 401) {
      const result = await RefreshTokenHandler.handleIt(err.response.data);
      if (result.status) {
        return getCompanyLoansAnalytics(params);
      }
    }
    throw err;
  }
};
const getCompanyContributionTrends = async (params: {
  email: string;
  company_code: string;
  period?: string;
  start_date?: string;
  end_date?: string;
}) => {
  const { email, company_code, period, start_date, end_date } = params;

  let url = `${Config.baseUrl}/company/analytics/contributions?email=${email}&company_code=${company_code}`;

  if (period) url += `&period=${period}`;
  if (start_date) url += `&start_date=${start_date}`;
  if (end_date) url += `&end_date=${end_date}`;

  try {
    return await axios.get(url, { headers: getHeaders() });
  } catch (err: any) {
    if (err.response?.data?.status === 401) {
      const result = await RefreshTokenHandler.handleIt(err.response.data);
      if (result.status) {
        return getCompanyContributionTrends(params);
      }
    }
    throw err;
  }
};

const getTopEmployeesAnalytics = async (params: {
  email: string;
  company_code: string;
  period?: string;
  start_date?: string;
  end_date?: string;
}) => {
  const { email, company_code, period, start_date, end_date } = params;

  let url = `${Config.baseUrl}/company/analytics/top-employees?email=${email}&company_code=${company_code}`;

  if (period) url += `&period=${period}`;
  if (start_date) url += `&start_date=${start_date}`;
  if (end_date) url += `&end_date=${end_date}`;

  try {
    return await axios.get(url, { headers: getHeaders() });
  } catch (err: any) {
    if (err.response?.data?.status === 401) {
      const result = await RefreshTokenHandler.handleIt(err.response.data);
      if (result.status) {
        return getTopEmployeesAnalytics(params);
      }
    }
    throw err;
  }
};

export {
  addCompany,
  getAllCompanies,
  getCompanyById,
  editCompany,
  getCompaniesByAMC,
  bulkUploadCompanies,
  getCompanyDashboardAnalytics,
  getCompanyFundsAnalytics,
  getCompanyEmployeesAnalytics,
  getCompanyLoansAnalytics,
  getCompanyContributionTrends,
  getTopEmployeesAnalytics,
};
